import React, { useEffect, useState } from "react";
import "./css/BannerS.css"

const BannerSection = () => {
  const [slides, setSlides] = useState([]);
  const [selectedSlide, setSelectedSlide] = useState(0);
  const slideIntervalDuration = 4000; // 4 seconds for automatic slide change

  // Fetch the slides data once on mount
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_SCHOOL}/items/slider?fields=*.*.*`)
      .then(response => response.json())
      .then(data => {
        const apiSlides = data.data || [];
        setSlides(apiSlides);
      })
      .catch(error => console.error('Error:', error));
  }, []);

  // Auto-advance the carousel when slides are available
  useEffect(() => {
    if (!slides.length) return;

    const slideInterval = setInterval(() => {
      setSelectedSlide(prevSlide => (prevSlide + 1) % slides.length);
    }, slideIntervalDuration);

    return () => clearInterval(slideInterval);
  }, [slides.length]);

  // Keep selectedSlide in range if slides change (e.g., data refresh)
  useEffect(() => {
    if (selectedSlide >= slides.length) {
      setSelectedSlide(0);
    }
  }, [slides.length, selectedSlide]);

  // Function to handle manual slide change (optional, if you still want controls)
  const handleManualChange = (direction) => {
    setSelectedSlide(prevSlide => {
      let newSlide = direction === "next" ? prevSlide + 1 : prevSlide - 1;
      if (newSlide < 0) newSlide = slides.length - 1; // Go to last slide if moving prev on first slide
      if (newSlide >= slides.length) newSlide = 0; // Go to first slide if moving next on last slide
      return newSlide;
    });
  };

  if (!slides.length) {
    return (
      <div className="container-fluid p-0">
        <div className="carousel slide">
          <div className="carousel-inner" role="listbox">
            <div className="carousel-item active">
              <img
                src="./slider1.jpeg"
                className="d-block w-100"
                alt="Loading slide"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="container-fluid p-0">
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
          <ol className="carousel-indicators">
            {slides.map((_, index) => (
              <li
                key={index}
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to={index}
                className={index === selectedSlide ? 'active' : ''}
              ></li>
            ))}
          </ol>
          <div className="carousel-inner" role="listbox">
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`carousel-item ${index === selectedSlide ? 'active' : ''}`}
              >
                <img
                  src={
                    slide?.image?.data?.full_url
                      ? slide.image.data.full_url.replace('http://', 'https://')
                      : './slider1.jpeg'
                  }
                  className="d-block w-100"
                  alt={`Slide ${index}`}
                />
              </div>
            ))}
          </div>
          <a
            className="carousel-control-prev"
            href="#carouselExampleIndicators"
            role="button"
            data-bs-slide="prev"
            onClick={() => handleManualChange('prev')}
          >
            <span className="carousel-control-prev-icon jj" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a
            className="carousel-control-next"
            href="#carouselExampleIndicators"
            role="button"
            data-bs-slide="next"
            onClick={() => handleManualChange('next')}
          >
            <span className="carousel-control-next-icon jj" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default BannerSection;
